import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { Application } from './models/ApplicationModels';

export class ApiApplication extends ApiHexaBase {
  public static applicationBaseUrl(id: string | number): string {
    return `${ApiHexaBase.baseUrl}/customers/${id}/applications`;
  }

  public static async index(id: string | number) {
    const response = await ApiBase.get(this.applicationBaseUrl(id));

    return response.data.data as Application[];
  }

  public static async create(id: string | number, data: Partial<Application>) {
    const response = await ApiBase.post(this.applicationBaseUrl(id), data);

    return response.data.data as Application;
  }

  public static async show(
    id: string | number,
    application_id: string | number
  ) {
    const response = await ApiBase.get(
      `${this.applicationBaseUrl(id)}/${application_id}`
    );

    return response.data.data as Application;
  }

  public static async update(
    id: string | number,
    application_id: string | number,
    data: Partial<Application>
  ) {
    const response = await ApiBase.post(
      `${this.applicationBaseUrl(id)}/${application_id}`,
      data
    );

    return response.data.data as Application;
  }
}
